import { useMemo } from 'react';
import { useLiveAssetLocationsQuery } from '@casops/store/apis/registeredAssetsApi';

export const useLiveAssetLocations = () => {
  const { data = {} } = useLiveAssetLocationsQuery();
  return useMemo(() => Object.values(data), [data]);
};
